import React from 'react'

const ProfilePicture = props => {
    const profileURL = 'https://ipmsapplication.blob.core.windows.net/profile/'
    return <img className="rounded-circle" src={`${profileURL}${props.email}.jpg`} width={props.size || 32} height={props.size || 32} alt={props.alt || props.email} />
}

export default ProfilePicture